<mat-icon (click)="toggle()" *ngIf="checked" style="color: green">check_box</mat-icon>
<mat-icon (click)="toggle()" *ngIf="!checked && !indeterminate" style="color: red;">disabled_by_default</mat-icon>
<ng-container *ngIf="indeterminate"><mat-icon (click)="toggle()">check_box_outline_blank</mat-icon> (Inherited from group)</ng-container>
